export const DRUH_LABELS = {
  A: "Surovina", SUR: "Surovina", SUROVINA: "Surovina",
  O: "Obal", OBAL: "Obal",
  PS: "Polotovar skladem",
  P: "Polotovar",
  PM: "Polotovar masná",
  PZ: "Polotovar zelenina",
};

const norm = (d) => (d || "").toString().trim().toUpperCase().replace(/\.$/, "");

export const druhLabel = (d) => DRUH_LABELS[norm(d)] || (d ? d.toString() : "—");

export const druhShort = (d) => {
  const n = norm(d);
  if (n === "A" || n === "SUR" || n === "SUROVINA") return "Sur.";
  if (n === "O" || n === "OBAL") return "Obal";
  return d ? d.toString() : "—";
};

export const druhBadgeClass = (d) => {
  const n = norm(d);
  if (n === "O" || n === "OBAL") return "border-secondary/40 text-secondary bg-secondary/5";
  if (["PS", "P", "PM", "PZ"].includes(n)) return "border-amber-500/50 text-amber-700 bg-amber-500/10";
  return "border-primary/40 text-primary bg-primary/5";
};
